import { PipelinesPermissions } from './pipelines.permissions';
import { PipelinesRoles } from './pipelines.roles';

export const pipelinesMappings = {
  [PipelinesPermissions.GET_PIPELINES_FOR_ACCOUNT]: [PipelinesRoles.VIEWER],
  [PipelinesPermissions.ADD_PIPELINE]: [PipelinesRoles.CREATOR],
  [PipelinesPermissions.EDIT_PIPELINE]: [PipelinesRoles.EDITOR],
  [PipelinesPermissions.DELETE_PIPELINE]: [PipelinesRoles.EDITOR],
};
